export const reformStoryItems = (storyItems) => {
  const result = {};

  // Group items by series and season
  storyItems.forEach((item) => {
    const [series, season, episode] = item.slug.split("/");
    //log("item 1 series",season);
    if (!result[series]) {
      result[series] = {};
    }

    if (!result[series][season]) {
      result[series][season] = [];
    }

    result[series][season].push({
      episodeSlug: episode,
      "published-at": item["published-at"],
    });
  });

  // Sort episodes within each season by 'published-at' (newest first)
  for (const series in result) {
    for (const season in result[series]) {
      result[series][season].sort((a, b) => a["published-at"] - b["published-at"]);
    }
  }

  // Reformat the result into the desired structure
  const reformedObject = Object.keys(result).map((series) => {
    const seasons = Object.keys(result[series]).map((season) => {
      return {
        [season]: result[series][season],
      };
    });

    return {
      [series]: seasons,
    };
  });

  return reformedObject;
}

export const findEpisodeIndex = (reformedObject, series, season, episodeSlug) => {
  // Find the series object
  const seriesObj = reformedObject.find((item) => item[series]);
  if (!seriesObj) {
    return -1; // Series not found
  }

  // Find the season array
  const seasonObj = seriesObj[series].find((item) => item[season]);
  if (!seasonObj) {
    return -1; // Season not found
  }

  // Find the episode index
  const episodeIndex = seasonObj[season].findIndex((episode) => episode.episodeSlug === episodeSlug);

  return episodeIndex; // Returns -1 if episode not found
};
